import { render, staticRenderFns } from "./frontBackaAppraisal_tea2.vue?vue&type=template&id=e6b7046c&scoped=true&"
import script from "./frontBackaAppraisal_tea2.vue?vue&type=script&lang=js&"
export * from "./frontBackaAppraisal_tea2.vue?vue&type=script&lang=js&"
import style0 from "./frontBackaAppraisal_tea2.vue?vue&type=style&index=0&id=e6b7046c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b7046c",
  null
  
)

export default component.exports